module["exports"] = [
  "#{last_name} #{first_name}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ja/name/name.js
// module id = 1085
// module chunks = 0